@if (begining && !isMoreVisible) {
  <span [innerHtml]="begining"></span>
}
@if (!begining && !isMoreVisible) {
  <span [innerHtml]="text"></span>
}
<span [class.ng-hide]="!isMoreVisible" [innerHtml]="text"></span>
@if (begining) {
  <span
    (click)="toggle()"
    class="cursor-pointer"
    [ngClass]="mobileReadMoreColor || 'col-6'"
    [ngStyle]="{'pointer-events': readMoreModalButton && readMoreModalId ? 'none' : 'auto'}"
    >&nbsp;{{ (isMoreVisible ? (readLess || '') : (readMore || '')) | translate }}
    @if (showIcon) {
      <i class="icon-read-more" [ngClass]="isMoreVisible ? 'icon-chevron-left' : 'icon-chevron-right'"></i>
    }
  </span>
}
@if (begining && readMoreModalButton && readMoreModalId) {
  <div>
    <button class="button-inline m-t-2 m-b-3"
      type="button"
      [iCmsModalOpen]="readMoreModalId"
      [iCmsModalOpenData]="readMoreModalData">
      <span class="p2">{{ readMoreModalButton }}</span>
    </button>
  </div>
}